"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.large = exports.medium = exports.small = exports.extraSmall = void 0;
var polished_1 = require("polished");
var styled_components_1 = require("styled-components");
var greaterThan = function (breakpoint, styles) {
    return function (_a) {
        var theme = _a.theme;
        return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (min-width: ", ") {\n        ", ";\n      }\n    "], ["\n      @media (min-width: ", ") {\n        ", ";\n      }\n    "])), (0, polished_1.rem)(theme.layout.breakpoints[breakpoint]), styles);
    };
};
var extraSmall = function (styles) { return greaterThan('XS', styles); };
exports.extraSmall = extraSmall;
var small = function (styles) { return greaterThan('S', styles); };
exports.small = small;
var medium = function (styles) { return greaterThan('M', styles); };
exports.medium = medium;
var large = function (styles) { return greaterThan('L', styles); };
exports.large = large;
var templateObject_1;
